import React, { useContext } from 'react';
import { useLocalize } from 'localize-react';
import { LocalizationContext } from '../localization/Localization';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import './language.scss';

export const Language: React.FC = () => {
  const { locale } = useLocalize();
  const { setLocale } = useContext(LocalizationContext);
  const [, setValue] = useLocalStorage('preferredLanguage');

  return (
    <div className="language-container">
      <select
        name="language"
        id="language"
        defaultValue={locale}
        onChange={e => {
          setValue('preferredLanguage', e?.target.value);
          setLocale(e?.target.value);
        }}
      >
        <option value="en">EN</option>
        <option value="nl">NL</option>
      </select>
    </div>

  );
};
